export function uniqueId(a) {
    return a
        ? (Number(a) ^ ((Math.random() * 16) >> (Number(a) / 4))).toString(16)
        : "".concat(1e7, "-").concat(1e3, "-").concat(4e3, "-").concat(8e3, "-").concat(1e11).replace(/[018]/g, uniqueId);
}
